import { IconButton, TableBody, TableRow, TextField } from "@mui/material";
import { GridMoreVertIcon } from "@mui/x-data-grid-pro";
import { useState } from "react";
import { fromIsoDateString } from "../../../../../common/helpers/formatDateTime";
import { ActionMenu } from "../tableItems/ActionMenu";
import { SalaryNumericFormat } from "./SalaryNumericFormat";
import { SalaryTableCell } from "./styles";

type Props = {
  fields: any[];
  baseComponentCodes: string[];
  personalComponentCodes: string[];
  extraComponentCodes: string[];
  onEdit: (index: number) => void;
  onRemove: (index: number) => void;
  onCopy: (index: number) => void;
  canEdit: boolean;
};

const SalaryTableBody = ({
  fields,
  baseComponentCodes,
  personalComponentCodes,
  extraComponentCodes,
  onEdit,
  onRemove,
  onCopy,
  canEdit,
}: Props) => {
  const [actionMenuAnchor, setActionMenuAnchor] = useState<{
    target: null | HTMLElement;
    id: string;
  }>({ target: null, id: "" });

  const getHourlyWorkTotalSalary = (fields: { [key: string]: string }) => {
    return Object.entries(fields).reduce((result, [key, value]) => {
      if (
        !isNaN(+value) &&
        baseComponentCodes.includes(key) &&
        !extraComponentCodes.includes(key)
      ) {
        return result + +value;
      }
      return result;
    }, 0);
  };

  return (
    <TableBody>
      {fields.map((field, index) => (
        <TableRow id={field.id} key={field.id}>
          <SalaryTableCell>
            <TextField
              value={fromIsoDateString(field.components.from, "dd.MM.yyyy")}
              disabled
              size="small"
            />
          </SalaryTableCell>
          <SalaryTableCell>
            <SalaryNumericFormat
              name="totalSalary"
              value={getHourlyWorkTotalSalary(field.components)}
              type="text"
            />
          </SalaryTableCell>
          {baseComponentCodes.map((code, ind, array) => (
            <SalaryTableCell
              key={code}
              sx={{
                borderLeft: ind === 0 ? "1px solid #00000061" : "none",
                borderRight:
                  ind === array.length - 1 ? "1px solid #00000061" : "none",
              }}
            >
              <SalaryNumericFormat
                name={code}
                value={field?.components[code]}
                type="input"
              />
            </SalaryTableCell>
          ))}
          {personalComponentCodes.map((code, ind, array) => (
            <SalaryTableCell
              sx={{
                borderRight:
                  ind === array.length - 1 && !!personalComponentCodes.length
                    ? "1px solid #00000061"
                    : "none",
              }}
            >
              <SalaryNumericFormat
                name={code}
                value={field?.components[code]}
                type="input"
              />
            </SalaryTableCell>
          ))}
          {extraComponentCodes.map((code) => (
            <SalaryTableCell>
              <SalaryNumericFormat
                name={code}
                value={field?.components[code]}
                type="input"
              />
            </SalaryTableCell>
          ))}
          {canEdit && (
            <>
              <SalaryTableCell align="left" sx={{ verticalAlign: "center" }}>
                <IconButton
                  onClick={(e) =>
                    setActionMenuAnchor({
                      target: e.currentTarget,
                      id: field.id,
                    })
                  }
                >
                  <GridMoreVertIcon />
                </IconButton>
              </SalaryTableCell>
              <ActionMenu
                key={field.id}
                open={!!actionMenuAnchor.target}
                anchorEl={actionMenuAnchor}
                onClose={() => setActionMenuAnchor({ target: null, id: "" })}
                index={index}
                id={field.id}
                isRowEditable={true}
                onDeleteRow={onRemove}
                onCopyRow={onCopy}
                onEdit={onEdit}
              />
            </>
          )}
        </TableRow>
      ))}
    </TableBody>
  );
};

export default SalaryTableBody;
